export interface SurveyEditorProps {
  contentId: string;
}

export const WELCOME_BLOCK_ID = 'WELCOME_BLOCK';
